import { SvTableHeaderItem } from "sv-chemistry-ng-lib";

export class TableHelper {
  private tableHeaders: SvTableHeaderItem[] = [];

  constructor(){
  }

  public findHeaderData(target: string){
    let count: number = this.tableHeaders.length;
    for(let k = 0; k<count; k++){
      if(this.tableHeaders[k].name === target){
        return this.tableHeaders[k];
      }
    }

    return {};
  }

  public updateHeaderValue(mappable: string[], headerNames: string[], field: string, updateValue: any) {
    mappable.map((updateHeader) => {
      let foundIndex = headerNames.indexOf(updateHeader);
      if (foundIndex >= 0) {
        this.tableHeaders[foundIndex][field] = updateValue;
      }
    })
  }

  public getTableHeaders() : SvTableHeaderItem[] {
    return this.tableHeaders;
  }

  public setTableHeaders(headers: SvTableHeaderItem[]) {
    this.tableHeaders = headers;
  }

  public getVisibleColumnCount() : number {
    return this.tableHeaders.filter(header => header.isShown).length;
  }
}

